import { formatDate} from '@/utils/common';
import { deleteDeviceAPI,  addDeviceAPI, editDeviceAPI, getListDeviceAPI, getDeviceInformation, getListSitesAPI} from '../../api/device-manager';

const state = {
  devices: [],
  listSites: [],
};

const mutations = {
  SET_DEVICES(state, payload) {
    state.devices = payload;
  },
  SET_SITES(state, payload) {
    state.listSites = payload;
  },
};

const actions = {
  getListDevice: async ({ commit }, params) => {
    commit('loading/SET_LOADING', true, { root: true });
    try {
        const result = await getListDeviceAPI(params);
        if (result && result.data) {
          const { data } = result;
          const items = data?.data.result.map((item) => ({
            date_of_commission: formatDate(item.date_of_commission),
            last_maintenance: formatDate(item.last_maintenance),
            next_maintenance: formatDate(item.next_maintenance),
            created_at: formatDate(item.created_at),
            updated_at: formatDate(item.updated_at),
            ...item
          }));
        commit('SET_DEVICES', items);
        commit('loading/SET_LOADING', false, { root: true });
        return data;
      }
    } catch (error) {
      console.log(error);
      commit('loading/SET_LOADING', false, { root: true });
    }
  },

  getDeviceInfo: async ({ commit }, id) =>{
    commit('loading/SET_LOADING', true, { root: true });
    try {
        const result = await getDeviceInformation(id);
        const updatedResult = {};
        if (result && result.data) {          
          Object.entries(result).forEach(([key, item]) => {
            updatedResult[key] = {
              ...item,
              date_of_commission: formatDate(item.date_of_commission),
              last_maintenance: formatDate(item.last_maintenance),
              next_maintenance: formatDate(item.next_maintenance),
              created_at: formatDate(item.created_at),
              updated_at: formatDate(item.updated_at),
            };
          });

        commit('loading/SET_LOADING', false, { root: true });
        return updatedResult;
      }
    } catch (error) {
      console.log(error);
      commit('loading/SET_LOADING', false, { root: true });
    }
  },

  getListSites: async ({ commit }, params) => {
    try {
      const result = await getListSitesAPI(params);
      if (result && result.data) {
        const { data } = result;
        const items = data?.data.sites?.map((item) => ({
          id: item.id,
          name: item.site_name,
          nexus_id: item.nexus_id
        }));
        commit('SET_SITES', items);
        return data;
      }
    } catch (error) {
      console.log(error);
      commit('loading/SET_LOADING', false, { root: true });
    }
},

  deleteDevice: async ({ commit }, params) => {
    commit('loading/SET_LOADING', true, { root: true });
    try {
      const result = await deleteDeviceAPI(params);
      if (result) {
        commit('loading/SET_LOADING', false, { root: true });
        return result
      }
    } catch (error) {
      console.log(error);
      commit('loading/SET_LOADING', false, { root: true });
    }
  },
  addDevice: async ({ commit }, params) => {
    commit('loading/SET_LOADING', true, { root: true });
    try {
      const result = await addDeviceAPI(params);
      if (result && result.data) {
        const { data } = result;
        commit('loading/SET_LOADING', false, { root: true });
        return data;
      }
    } catch (error) {
      console.log(error);
      commit('loading/SET_LOADING', false, { root: true });
    }
  },
  editDevice: async ({ commit }, params) => {
    commit('loading/SET_LOADING', true, { root: true });
    try {
      const result = await editDeviceAPI(params);
      if (result && result.data) {
        const { data } = result;
        commit('loading/SET_LOADING', false, { root: true });
        return data;
      }
    } catch (error) {
      console.log(error);
      commit('loading/SET_LOADING', false, { root: true });
    }

  },
};

const getters = {
  getterDeviceManager: (state) => state.devices,
  getterSites: (state) => state.listSites,
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true,
};
